import React, { PropsWithChildren, ReactElement, useRef } from 'react';
import classes from './ResourceSelection.module.scss';
import { Stack } from 'new/elements/Stack';
import { Slide } from '@mui/material';
import classnames from 'classnames';

interface DrawerProps {
  open: boolean;
  children: ReactElement;
  onClose?: () => void;
  fixed?: boolean;
}

export const Drawer = (props: DrawerProps) => {
  const { children, open, fixed = true } = props;
  const containerRef = useRef();
  return (
    <Stack
      className={classnames(classes.drawerContainer, {
        [classes.drawerContainer_open]: open,
        [classes.drawerContainer_fixed]: fixed,
      })}
    >
      {open ? (
        <div
          className={classnames(classes.modalFader, {
            [classes.modalFader_fixed]: fixed,
          })}
          onClick={props.onClose}
        />
      ) : null}
      <Stack alignSelf="flex-end" ref={containerRef} position="relative" height="100%" width="80%">
        <Slide
          container={containerRef.current}
          in={open}
          direction="left"
          mountOnEnter
          unmountOnExit
        >
          {children}
        </Slide>
      </Stack>
    </Stack>
  );
};
